import { useContextState } from "../../../../../../../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    cleanFilters: {
      fontSize: '14px',
      cursor: 'pointer',
      color: colors.color16,
      minHeight: '35px',
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: '10px'
    },
    grid: {
      flexGrow: 1
    },
    gridLeft: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      '&.left': {
        borderRight: `1px solid ${colors.color13}`,
      }
    }
  }
}
